import React from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Translate } from "react-redux-i18n";
import PropTypes from "prop-types";
import { TDefaultImgObj, TImgObj } from "assets/js/scenes/brand/PropTypes";
import BrandElement from "assets/js/scenes/brand/components/brandElements/BrandElement";
import { getCurrentBrandFromState } from "assets/js/scenes/brand/utils";
import BrandImageSelection from "assets/js/scenes/brand/components/brandElements/BrandImageSelection";

export const LogoBrandElement = (props) => {
	return (
		<BrandElement
			title={
				<Translate
					value={`app-brand-${props.channelStringsKey}-${props.name}-title`}
				/>
			}
			desc={
				<Translate
					value={`app-brand-${props.channelStringsKey}-${props.name}-desc`}
				/>
			}
			path={props.path}
			rightPanel={
				<BrandImageSelection
					imgObj={props.imgObj}
					defaultImgObj={props.defaultImgObj}
					path={props.path}
					goToSDK={props.goToSDK}
					usePrimary={props.usePrimary}
				/>
			}
		/>
	);
};

LogoBrandElement.propTypes = {
	localBrand: PropTypes.object,
	brand: PropTypes.object,
	goToSDK: PropTypes.func,
	path: PropTypes.string,
	channelStringsKey: PropTypes.string,
	name: PropTypes.string,
	stylePath: PropTypes.string,
	usePrimary: PropTypes.bool,
	imgObj: PropTypes.shape(TImgObj),
	defaultImgObj: PropTypes.shape(TDefaultImgObj),
};

LogoBrandElement.defaultProps = {};

export default withRouter(
	connect(
		(state) => {
			return {
				localBrand: state.localBrand.data,
				brand: getCurrentBrandFromState(state),
			};
		},
		(dispatch) => bindActionCreators({}, dispatch)
	)(LogoBrandElement)
);
